export const authMixin = {
  data() {
    return {
      loading_code: false,
      model: {
        email_auth_code: null,
      },
    };
  },
  methods: {
    create2FACode() {
      this.loading_code = true;
      this.$http({
        method: "POST",
        url: "/api/v1/client/auth_codes",
        headers: {
          "Content-Type": "application/jsson",
          Authorization: this.$store.getters.authToken,
        },
      })
        .then(() => {
          this.$toasted.show("Code Sent To Your Email", {
            position: "top-right",
            duration: 5000,
            type: "success",
            closeOnSwipe: true,
          });

          this.loading_code = false;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading_code = false;
        });
    },
  },
};
